import { Directive, ElementRef, inject, Input, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { ThemeService } from '../utils/theme-service.service';
import { E_ThemeOption } from '../enums/themes.enum';

@Directive({
  selector: '[switchThemeLogo]',
  standalone: false,
})
export class SwitchThemeLogoDirective {

  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private theme = inject(ThemeService);

  @Input('switchThemeLogo') logoPaths!: {
    [E_ThemeOption.Light]: string,
    [E_ThemeOption.Dark]: string
  };

  public sub?: Subscription;

  constructor() { }

  ngOnInit() {
    this.sub = this.theme.getTheme().subscribe((theme: Omit<E_ThemeOption, E_ThemeOption.System>) => {
      const themeKey = theme as keyof typeof this.logoPaths;
      const selectedLogoPath = this.logoPaths[themeKey];
      if (selectedLogoPath) {
        this.renderer.setAttribute(this.el.nativeElement, 'src', selectedLogoPath);
      }
    })
  }

  ngOnDestroy() {

  }

}
